import { useTranslations, cx } from "@jugl-web/utils";
import { ListBox, Popover } from "@jugl-web/ui-components/cross-platform";
import { useInvoicesItemFormPageContext } from "@web-src/modules/invoices/pages/InvoicesItemFormPage/context/useInvoicesItemFormPageContext";
import { useRef } from "react";
import { statusOptions } from "./constants";
import { ReactComponent as ChevronDownIcon } from "./assets/chevron-down.svg";
import { ReactComponent as CalendarIcon } from "./assets/calendar.svg";

export const StatusField = () => {
  const { t } = useTranslations();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { formValues, setFieldValue } = useInvoicesItemFormPageContext();

  const displayValue = statusOptions.find(
    (item) => item.id === formValues.status
  )?.value;

  return (
    <div className="w-full" ref={wrapperRef}>
      <label className="mb-2 block pl-2.5 font-secondary text-[15px] font-normal text-dark-700">
        {t({
          id: "invoices.item.status",
          defaultMessage: "Status",
        })}
      </label>

      <Popover
        placement="bottom-start"
        className="px-3 py-2"
        renderTrigger={({ Trigger, triggerRef, isOpen }) => (
          <Trigger
            ref={triggerRef}
            className="flex h-14 w-full cursor-pointer items-center justify-between rounded-xl border border-solid border-grey-400 bg-transparent px-5 text-base font-normal text-dark outline-none"
          >
            {displayValue}
            <ChevronDownIcon
              className={cx(
                "shrink-0 transition-transform",
                isOpen && "rotate-180"
              )}
            />
          </Trigger>
        )}
      >
        {({ onClose }) => (
          <div
            className="relative"
            style={{ width: (wrapperRef.current?.offsetWidth || 0) - 24 }}
          >
            <ListBox
              items={statusOptions}
              selectionBehavior={{ mode: "single", canToggle: true }}
              onSelect={(item) => {
                setFieldValue("status", item.id);
                onClose();
              }}
              defaultSelectedIds={[formValues.status]}
              renderLabel={(item) => item.value}
              renderEndIcon={(item) =>
                item.id === "custom" ? <CalendarIcon /> : null
              }
              itemSize="sm"
              spaceBetweenItems="compact"
            />
          </div>
        )}
      </Popover>
    </div>
  );
};
